import React, { useCallback, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle } from 'styled-components';
import { Collapse } from 'react-collapse';
import { useLocation } from 'react-router';

import OcrHeader from '../OcrHeader';
import RecommendList from './RecommendList';
import { useDispatch, useSelector } from 'react-redux';
import { TYPE } from '../../../constant';
import { useAppOcrOnOff, useUserInfo } from '../../../hooks';
import { mathpidLogAPICall } from '../../../redux/logData';
import useAmplitude from '../../../hooks/useAmplitude';
import { appsflyer, appsflyerEventName } from '../../../utils/appsflyer';

const GlobalStyle = createGlobalStyle`
  .ReactCollapse--collapse {
    transition: height 500ms;
  }
`;

// background: ${props =>
//   props.imagePath ? `url(${props.imagePath}) repeat 50% -10%;` : "url('../static/images/tmp/img_sample_02@2x.png') repeat 50% -10%;"
// };
// background-attachment: fixed;
// background-size: auto;
// left: 0;
// top: 0;
const ImgWarp = styled.div`
  &&& {
    left: 0;
    top: 0;
    height: 400px;
    background: ${props => props.imagePath ? `url(${props.imagePath});` : "url('../static/images/tmp/img_sample_02@2x.png')"};
    position: fixed;
    background-size: cover;
    background-repeat: round;
  }
`;

const touchY = {
  start: 0, end: 0,
}
function Recommend() {
  const location = useLocation();
  const logDispatch = useDispatch();
  const ocrRef = useRef(null);
  const { info } = useUserInfo();
  const { t } = useTranslation();
  const { setAmplitudeLog } = useAmplitude();

  const [scrollDir, setScrollDir] = useState("");
  const [fulls3path, setImage] = useState("");
  const [isView, setView] = useState(false);
  const [latex, setLates] = useState("");
  const [headerHeight, setHeaderHeight] = useState(80);
  const [imgDiv, setImgDiv] = useState({ open: true, height: 200 });

  const { appOcrOnOff } = useAppOcrOnOff();
  const deviceInfo = useSelector(state => state.deviceInfo);
  useEffect(() => {
    const ocrHeaderDom = document.getElementById("ocrHeader");
    if (ocrHeaderDom) {
      setHeaderHeight(ocrHeaderDom.offsetHeight);
    }

    const threshold = 0;
    const { state } = location;
    let isCancelled = false;
    let ticking = false;
    let lastScrollY = window.pageYOffset;
    let isFind = '';

    if (state && state?.fulls3path) setImage(state.fulls3path);
    if (state && state?.latex) setLates(state.latex);
    if (state && state?.data && state.data.length > 0) isFind = 'Y';
    else isFind = 'N';

    setAmplitudeLog({
      eventName: {
        name: 'ocr소주제추천 조회',
        event: {
          '소스화면': '',
          'ocr 추천 성공 여부': isFind,
        }
      },
      isHackleSend: true,
    })

    appsflyer({
      eventName: appsflyerEventName.camera_completed,
      eventParams: {
        af_success: isFind
      }
    });

    // 네이티브 뒤로가기 on off
    if (state && state.isBack === 'Y') appOcrOnOff("N");
    else appOcrOnOff('Y');


    // scroll up down 이벤트 확인
    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      if (!isCancelled) setScrollDir(scrollY > lastScrollY ? "down" : "up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    // scroll, touchend 이벤트 함수
    const onScrollAndTouchend = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };
    
    // pc 버전일 땐 scroll, 그 외는 touchend event listener 발생
    if (deviceInfo.type === TYPE.DEVICE.PC) {
      window.addEventListener("scroll", onScrollAndTouchend);
    } else {
      window.addEventListener('touchend', onScrollAndTouchend);
    }


    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0002_0001',
    }));

    return () => {
      isCancelled = true;
      // event listener 종료
      window.removeEventListener("scroll", onScrollAndTouchend);
      window.removeEventListener('touchend', onScrollAndTouchend);
    }

  }, []);

  useEffect(() => {
    const ocrScrollWarpDom = document.getElementById("ocr_scroll_wrap");

    // scroll down일 때 orc추천 리스트의 scroll 활성화
    if (scrollDir === "down") {
      ocrScrollWarpDom.style.overflow = "scroll";
      setImgDiv({ open: false, height: 0 });
    }
  }, [scrollDir]);

  const ocrScrollWarpEvent = useCallback((e) => {

    const deltaY = e?.deltaY;
    const ocrScrollWarpDom = document.getElementById("ocr_scroll_wrap");
    const endTouch = e?.changedTouches ? e.changedTouches[0] : null;
    const startTouch = e?.touches ? e.touches[0] : null;
    
    // const ocrHeaderDom = document.getElementById("ocrHeader");
    // if (ocrHeaderDom) {
    //   setHeaderHeight(ocrHeaderDom.offsetHeight);
    // }
    
    // document.getElementById("img_wrap").style.backgroundAttachment = "";
    // document.getElementById("img_wrap").style.backgroundSize = "contain";
    // ocr추천 리스트 div의 scroll y축이 0 보다 클 때
    if (deltaY && deltaY > 0) return;
    
    // touch event start, end Y값 저장
    if (startTouch) touchY.start = startTouch?.pageY;
    if (endTouch) touchY.end = endTouch?.pageY;
    
    const point = touchY.start - endTouch?.pageY;

    if (point > 0 && point < 50) return;
    if (point < 0 && point > -50) return;
    
    // touch가 down이 아닐 때
    if ((touchY.start - endTouch?.pageY) > 100
      || touchY.start === endTouch?.pageY
    ) return;
    
    // ocr 추천학습 div의 scroll이 Top에 있을 때 scroll 비활성화
    if (ocrScrollWarpDom.scrollTop === 0) {
      setImgDiv({ open: true, height: 400 });
      ocrScrollWarpDom.style.overflow = "hidden";
    }

    
  }, [imgDiv, headerHeight]);

  return (
    <React.Fragment>
      <GlobalStyle />
      <div
        ref={ocrRef}
        id="ocr_offer"
        className={clsx({
          "layout-def not_flex header_absolute": true,
          "ocr_offer header_white_cont": isView,
          "gb": info.channelCode === TYPE.CHANNEL.GLOBAL01
        })}
      >
        <OcrHeader
          title={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? t("LC_09_04.msg001") : 'OCR 학습'}
          headerStyle={{
            position: "fixed",
            display: "flex"
          }}
          headerColorClassName={!imgDiv.open ? "bg_white" : ""}
        />
        <Collapse
          id="collapse"
          isOpened={imgDiv.open}
          style={{ display: isView ? '' : 'none' }}
        >
          <div style={{height: imgDiv.height}}>
            <ImgWarp
              id="img_wrap"
              imagePath={fulls3path}
              className="img_wrap"
            />
          </div>
        </Collapse>
        <RecommendList
          latex={latex}
          isView={isView}
          setView={setView}
          setImgDiv={setImgDiv}
          imgDivOpen={imgDiv.open}
          headerHeight={headerHeight}
          ocrScrollWarpEvent={ocrScrollWarpEvent}
        />
      </div>
    </React.Fragment>
  );
}

export default Recommend;